import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path d="M4 2h5v20H4V2zm11 0h5v20h-5V2z" fillRule="evenodd" /></svg>);